var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0002 23.3333C47.0726 23.3333 53.8554 26.1428 58.8563 31.1438C63.8573 36.1448 66.6668 42.9276 66.6668 50C66.6668 57.0724 63.8573 63.8552 58.8563 68.8562C53.8554 73.8571 47.0726 76.6667 40.0002 76.6667C32.9277 76.6667 26.145 73.8571 21.144 68.8562C16.143 63.8552 13.3335 57.0724 13.3335 50C13.3335 42.9276 16.143 36.1448 21.144 31.1438C26.145 26.1428 32.9277 23.3333 40.0002 23.3333ZM40.0002 35L35.5902 43.9333L25.7335 45.3667L32.8668 52.3167L31.1835 62.1367L40.0002 57.5L48.8168 62.1333L47.1335 52.3167L54.2668 45.3633L44.4102 43.93L40.0002 35ZM43.3335 6.66333L60.0002 6.66666V16.6667L55.4568 20.46C51.6866 18.4819 47.5704 17.2494 43.3335 16.83V6.66666V6.66333ZM36.6668 6.66333V16.83C32.4313 17.2488 28.3162 18.4802 24.5468 20.4567L20.0002 16.6667V6.66666L36.6668 6.66333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalFill);
export default __webpack_public_path__ + "static/media/medal-fill.abee4d7245e61736d5aaef4d7117e990.svg";
export { ForwardRef as ReactComponent };